//------------------------------------------------------------------------------
// BFA10102G 共架申込基本情報
//------------------------------------------------------------------------------
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import Paper from '@mui/material/Paper';
import { renderTextField } from '@/components/atoms/CustomPart';

/**
 * 申込メモパネル
 */
function OrderMemoPanel({ updatable }) {
  //
  // 描画
  //
  return (
    <Paper elevation={3} sx={{ px: 3, py: 2 }}>

      {/* メモ欄 */}
      <Field name="memo" label="メモ内容"
        fullWidth component={renderTextField}
        multiline variant="outlined"
        InputProps={{ readOnly: !updatable }}
        sx={{

          // 高さをフルにする
          height: '100%',

          // 子要素の高さもフルにする
          '& .MuiInputBase-root': {
            height: '100%',
            alignItems: 'start',
          },
        }}
      />
    </Paper>
  );
}

// デフォルトエクスポート
export default OrderMemoPanel;
